/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComponentSchema } from './ComponentSchema';
import {
    ComponentSchemaFromJSON,
    ComponentSchemaFromJSONTyped,
    ComponentSchemaToJSON,
} from './ComponentSchema';

/**
 * 
 * @export
 * @interface PolicySchema
 */
export interface PolicySchema {
    /**
     * 
     * @type {number}
     * @memberof PolicySchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof PolicySchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof PolicySchema
     */
    updated: Date;
    /**
     * 
     * @type {ComponentSchema}
     * @memberof PolicySchema
     */
    component: ComponentSchema;
    /**
     * 
     * @type {string}
     * @memberof PolicySchema
     */
    arn?: string;
}

/**
 * Check if a given object implements the PolicySchema interface.
 */
export function instanceOfPolicySchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "component" in value;

    return isInstance;
}

export function PolicySchemaFromJSON(json: any): PolicySchema {
    return PolicySchemaFromJSONTyped(json, false);
}

export function PolicySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicySchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'component': ComponentSchemaFromJSON(json['component']),
        'arn': !exists(json, 'arn') ? undefined : json['arn'],
    };
}

export function PolicySchemaToJSON(value?: PolicySchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'component': ComponentSchemaToJSON(value.component),
        'arn': value.arn,
    };
}

